// extracted by mini-css-extract-plugin
module.exports = {"shbar":"link_shbar__Ht34K","mdi":"link_mdi__wVjy7","text":"link_text__SreEI"};